import React from 'react';
import { debounce } from '@material-ui/core';
import { FormControl, InputGroup } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import utils from '../../utils';
import { APIUtiltity } from '../../API';
import { ReactComponent as Search } from '../../img/svg/Actions/Search.svg';

function SearchInput() {
  const history = useHistory();

  const searchBrandOrStar = async (search = '') => {
    if (search.length < 3) return;
    const res = await APIUtiltity.searchBrandOrStar(search);
    if (res.status === 200) {
      const data = res.data.data?.[0] || {};
      let route = '';
      if (res.data?.type === 'star' && data.isStarProfileSetup) {
        route = `/StarProfile/${utils.getEncrypted({ starId: data.walletId })}`;
      } else if (res.data?.type === 'snft') {
        route = '/BrandClubDetails/' + utils.getEncrypted({ sNftId: data._id });
      } else route = '/MarketHub';
      history.push(route);
    } else history.push('/MarketHub');
    const input = window.document.getElementById('globalSearch');
    if (input) input.value = '';
  };

  return (
    <InputGroup
      onChange={debounce((e) => searchBrandOrStar(e.target.value), 500)}
      className="global-search-input"
    >
      <InputGroup.Text>
        <Search />
        <FormControl id="globalSearch" placeholder="Enter Campaign Club/Creator" />
      </InputGroup.Text>
    </InputGroup>
  );
}

export default SearchInput;
